// @core/api/endpoints/payment/list_payments.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentsResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List payments
 * Returns a paginated list of payments. Supports filtering and sorting.
 */
export async function ListPayments(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPaymentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payments`;
  const requestOptions = options;
  return client.get<ListPaymentsResponse>(requestPath, { ...requestOptions, params });
}
